export const EVENTS = {
  RESTAURANT_SEARCH: {
    REQUEST: 'restaurantSearch:request',
    LOAD_MORE: 'restaurantSearch:loadMore',
    LOADING: 'restaurantSearch:loading',
    LOADING_MORE: 'restaurantSearch:loadingMore',
    LOADED: 'restaurantSearch:loaded',
    LOADED_MORE: 'restaurantSearch:loadedMore',
    ERROR: 'restaurantSearch:error'
  }
};

export const ENDPOINTS = {
  RESTAURANT_SEARCH: '/restaurant/search?group=ultraxeno&status=approved',
  RESTAURANT_SEARCH: '/restaurant/list?group=ultraxeno&status=approved',
  RESTAURANT_LIST: '/restaurant/list?group=ultraxeno&status=approved'
};

export const DEFAULT_STATE = {
  restaurants: [],
  loading: false,
  error: null,
  totalCount: 0,
  hasMore: false,
  page: 1,
  limit: 20,
  searchQuery: '',
  filters: {}
};
